import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import Component, { type Props } from "./component";
import { styleSelector } from "./selectors";

const mapStateToProps = (state: AppState, props: WithChildren): Props => ({
  ...props,
  style: styleSelector(state)
});

export default connectCustom(mapStateToProps)(Component);
